"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const buildCallableIsCurrentUserEmailVerified = (args) => async ({ functionId, callbacks, executeProcesses, processor, }) => {
    const { currentUser } = processor.root.firebase.auth();
    if (!currentUser) {
        executeProcesses(undefined, callbacks.userIsNotLoggedIn);
        return;
    }
    if (processor.root.isInDevelopment) {
        const projectId = processor.root.getProjectId();
        if (!projectId) {
            throw new Error('No project Id found');
        }
        const emailIsVerified = await args
            .checkInLocalIfUserEmailVerified(currentUser.uid, projectId);
        if (emailIsVerified) {
            executeProcesses(functionId, callbacks.isVerified);
            return;
        }
        executeProcesses(functionId, callbacks.isNotVerified);
        return;
    }
    const appId = processor.root.getAppId();
    if (!appId) {
        throw new Error('No app Id found');
    }
    const emailIsVerified = await args.checkInHostIfAuthUserEmailIsValidated(appId);
    if (emailIsVerified) {
        executeProcesses(functionId, callbacks.isVerified, currentUser);
    }
    else {
        executeProcesses(functionId, callbacks.isNotVerified);
    }
};
exports.default = buildCallableIsCurrentUserEmailVerified;
